<template>
  <v-row justify="center">
    <v-dialog v-model="editDialog" persistent max-width="500px">
      <v-card class="#FFCD" color="#f9f9f9">
        <v-card-title> Edit Author </v-card-title>
        <v-form ref="form" lazy-validation class="mr-6 ml-6 pb-6">
          <v-card class="rounded-larg rounded-lg" elevation="3" tile>
            <v-list-item>
              <v-list-item-content class="pl-3 pr-3">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      :rules="[rules.required, rules.maxvalue]"
                      v-model="editItem.authorname"
                      label="Name"
                      outlined
                      dense
                      required
                      @keyup.enter="submit"
                    ></v-text-field>

                    <v-text-field class="d-none"></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close()"
                    >Close</v-btn
                  >
                  <v-btn
                    data-cy="submitBTN"
                    color="blue darken-1"
                    text
                    @click="submit"
                    :loading="loadingEdit"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["editDialog", "editItem"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        maxvalue: (value) =>
          value.length <= 64 || "Maximum length is 64 characters",
      },

      loadingEdit: false,
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        let DataForm = {
          Param: {
            authorname: this.editItem.authorname,
          },
          API: "/admin/author/" + this.editItem.authorid,
        };
        this.$store
          .dispatch("PutToAPI", DataForm)
          .then((response) => {
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.loadingEdit = false;
            this.$emit("DialogClose", true);
          })
          .catch(() => {
            this.loadingEdit = false;
            this.$store.dispatch("PushErrorMsg", "Validation Error");
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    close() {
      this.$emit("DialogClose", false);
    },
  },
};
</script>